import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import config from "./ChartScatterUtlisationConfig";
import {
  NitroLoading,
  NitroContentNotAvailable,
  NitroText
} from "nitro-components";

import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import RHC from "react-highcharts";

import utilisation from "../highcharts-themes/utilisation";
import smplTheme from "../highcharts-themes/smpl";
import { getColour } from "../highcharts-themes/helper";
import {
  utilisation_plots,
  utlisation_colors,
  getUtilisationPlotbandLabel,
  getVehicleUtilisationToolTip
} from "../custom-styles/UtilisationStyleHelpers";

import ChartLegend from "../custom-styles/ChartLegend";

import { merge } from "lodash";

import styled from "styled-components";

const ScatterPlotPanel = styled.div`
    & .highcharts-point {
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.15);
    }
`;

let chartInstance;

exporting(Highcharts);

const ReactHighcharts = RHC.withHighcharts(Highcharts);

const calculateMinMaxAndInterval = (
  heighestPoint,
  lowestPoint,
  buffer,
  underUpperThreshold,
  upperLowerThreshold
) => {
  const abstMin = Math.abs(lowestPoint);
  const abstMax = Math.abs(heighestPoint);

  let min = lowestPoint;
  let max = heighestPoint;

  if (abstMin < abstMax) {
    min = -abstMax + 100;
    max = abstMax + 100;
  } else {
    max = abstMin + 100;
    min = -abstMin + -100;
  }

  min = min - buffer;
  max = max + buffer;

  const tickInterval = Math.round((abstMax + abstMin) / 8);

  return { min, max, tickInterval };
};

class ChartScatterPlot extends Component {
  constructor(props) {
    super(props);
    //addArrowToAxis();
    this.state = {
      title: null
    };
  }


  //Performancer improvement for scatterr plot to not renrender on every click
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.data.title.text != this.props.data.title.text;
  }

  componentDidMount() {
    if (this.refs.chart) chartInstance = this.refs.chart.getChart();
}

  export = option => {
    const data = this.props.data;

    const chart = this.refs.chart;
   this.refs.chart.getChart().exportChart(option);
   // this.props.exportDocument(chart.getChart().getSVG(), option);
  }

  //NEED TO DO PERFORMANCE OPTIMISATIONS
  render() {
    const {   data, plotOptions } = this.props;
    const { limits } = data;
    const { min, max, tickInterval } = calculateMinMaxAndInterval(
      limits.heigestPoint.YAxis,
      limits.lowestPoint.YAxis,
      limits.buffer,
      limits.underUpperThreshold
    );

    if (data && plotOptions) {
      const chartConfig = merge({}, data, config, {
        title: {
          text: null
        },
        legend: {
          margin: 30,
          enabled: true,
        },
        yAxis: {
          tickInterval: tickInterval,
          min: min,
          max: max,
          plotBands: [
            {
              // visualize the weekend
              from: min,
              to: limits.underUpperThreshold,
              color: utlisation_colors.under_plotband_color,
              filters: {
                categoryGroupFilter: "Under utilised"
              },
              cursor: "pointer",
              events: {
                ...plotOptions.yAxis.plotBands.events,
                //click: function(e) {},
                mouseover: function(e) {
                  /*this.label.attr({
                    text: getUtilisationPlotbandLabel("under", true)
                  });*/
                  console.log(Highcharts.Color(this.options.color).brighten(0.08).get());
                 this.svgElem.attr(
                    "fill",
                    Highcharts.Color(this.options.color).brighten(0.08).get()
                  );
                },
                mouseout: function(e) {
                  /*this.label.attr({
                    text: getUtilisationPlotbandLabel("under", false)
                  });*/
                  this.svgElem.attr("fill", this.options.color);
                }
              }
            },
            {
              // Accetable plot band
              from: limits.underUpperThreshold,
              to: limits.upperLowerThreshold,
              filters: {
                categoryGroupFilter: "Acceptable"
              },
              color: utlisation_colors.acceptable_plotband_color,
              cursor: "pointer",
              events: {
                ...plotOptions.yAxis.plotBands.events,
                mouseover: function(e) {
                  this.svgElem.attr(
                      "fill",
                      Highcharts.Color('#000000').setOpacity(0.2).get()
                    );
                },
                mouseout: function(e) {
                  this.svgElem.attr("fill", this.options.color);
                }
              }
            },
            {
              from: limits.upperLowerThreshold,
              to: max,
              color: utlisation_colors.over_plotband_color,
              /*label: {
                useHTML: true,
                text: getUtilisationPlotbandLabel("over", false),

                x: 10,
                y: -50
              },*/
              //for filter clicking
              filters: {
                categoryGroupFilter: "Over utilised"
              },
              cursor: "pointer",
              events: {
                //click: function(e) {},
                ...plotOptions.yAxis.plotBands.events,
                mouseover: function(e) {
                  /*this.label.attr({
                    text: getUtilisationPlotbandLabel("over", true)
                  });*/
                  this.svgElem.attr(
                    "fill",
                    Highcharts.Color(this.options.color).brighten(0.07).get()
                  );
                },
                mouseout: function(e) {
                  /*this.label.attr({
                    text: getUtilisationPlotbandLabel("over", false)
                  });*/
                  this.svgElem.attr("fill", this.options.color);
                }
              }
            }
          ]
        }
        //tooltip: getVehicleUtilisationToolTip()
      });

         if(!data)
       return <NitroContentNotAvailable />

      return (
        <ScatterPlotPanel>
          <ReactHighcharts
            ref="chart"
            config={chartConfig}
            callback={this.afterRender}
            domProps={{ value: 123 }}
          />
          {/*for now hardcoding legends .. TODO change this future*/}
         {/** <ChartLegend
            data={[
              { value: "Over Utilised", variant: "negative" },
              { value: "Under Utilised", variant: "under" }
            ]}
          />**/}
        </ScatterPlotPanel>
      );
    } else {
      return <NitroLoading center thickness={2} size={24} />;
    }
  }
}

ChartScatterPlot.propTypes = {
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool, // TODO .isRequired
  exportDocument: PropTypes.func
};

export default ChartScatterPlot;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartScatterPlot.js